import { login, getInfo, getCompanyInfo, phoneLogin } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  roles: [],
  userInfo: {},
  companyInfo: {},
  userType: '',
  authStatus: '',
  dialogBindPhone: false
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_COMPANYINFO: (state, companyInfo) => {
    state.companyInfo = companyInfo
  },
  SET_AUTHSTATUS: (state, companyInfo) => {
    state.authStatus = companyInfo
  },
  SET_USERTYPE: (state, userType) => {
    state.userType = userType
  },
  SET_DIALOG_BIND_PHONE: (state, dialogBindPhone) => {
    state.dialogBindPhone = dialogBindPhone
  }
}

const actions = {
  // 用户登录
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        commit('SET_TOKEN', response.access_token)
        setToken(response.access_token)
        resolve()
      }).catch(error => {
        console.log("catch:"+error)
        reject(error)
      })
    })
  },
  // 手机号登录
  phoneLogin({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      phoneLogin(userInfo).then(response => {
        commit('SET_TOKEN', response.access_token)
        setToken(response.access_token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 用户登录
  // codelogin({ commit }, userInfo) {
  //   return new Promise((resolve, reject) => {
  //     if (userInfo.grant_type === 'password') {
  //       codeLogin(userInfo).then(response => {
  //         commit('SET_TOKEN', response.access_token)
  //         setToken(response.access_token)
  //         resolve()
  //       }).catch(error => {
  //         reject(error)
  //       })
  //     } else {
  //       phoneLogin(userInfo).then(response => {
  //         commit('SET_TOKEN', response.access_token)
  //         setToken(response.access_token)
  //         resolve()
  //       }).catch(error => {
  //         reject(error)
  //       })
  //     }
  //   })
  // },

  // 获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { user } = response
        if (!user) {
          reject(new Error('Verification failed, please Login again.'))
        }
        const { checkAuth, userName, avatar, userType, authStatus } = user
        const roles = [checkAuth]

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject(new Error('getInfo: roles must be a non-null array!'))
        }

        if (user.phone == '') {
          commit('SET_DIALOG_BIND_PHONE', true)
        } else {
          commit('SET_DIALOG_BIND_PHONE', false)
        }
        //
        console.log('是否认证↓')
        console.log(authStatus)
        commit('SET_ROLES', roles)
        commit('SET_NAME', userName)
        commit('SET_AVATAR', avatar)
        commit('SET_USERINFO', user)
        commit('SET_AUTHSTATUS', authStatus)
        commit('SET_USERTYPE', userType)
        if (user.companyId != null && user.companyId != '') {
          getCompanyInfo({ id: user.companyId }).then(res => {
            commit('SET_COMPANYINFO', res.result)
          }).catch(() => {
            commit('SET_COMPANYINFO', { companyName: '' })
          })
        } else {
          commit('SET_COMPANYINFO', { companyName: '' })
        }
        resolve(user)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 用户登出
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('SET_ROLES', [])
      commit('SET_NAME', '')
      commit('SET_AVATAR', '')
      commit('SET_USERINFO', {})
      commit('SET_USERTYPE', '')
      commit('SET_AUTHSTATUS', '')
      commit('SET_TOKEN', '')
      removeToken()
      resetRouter()
      resolve()
      // logout(state.token).then(() => {
      //   commit('SET_ROLES', [])
      //   commit('SET_NAME', '')
      //   commit('SET_AVATAR', '')
      //   commit('SET_USERINFO', {})
      //   commit('SET_USERTYPE', '')
      //   commit('SET_TOKEN', '')
      //   removeToken()
      //   resetRouter()
      //   resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // 删除token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
